import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Content, Platform } from 'ionic-angular';
// import { PhotoLibrary } from '@ionic-native/photo-library';
import { PhotoLibrary } from './../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { HttpChildProvider } from '../../../providers/http-child';
import { HttpChatProvider } from '../../../providers/http-chat';
import { ReserveAction } from '../../../actions/reserve.action';
import { AbstractPage } from '../../../pages/_com/abstract-page';
import { ReserveDetailPage } from '../../reserve/detail/reserve-detail';
import { ChildEditPage } from '../edit/child-edit';
import { BasicState } from '../../../states/basic-state';
import { Subscription } from 'rxjs/Subscription';
import Utils from '../../../_com/utils';

/**
 * Generated class for the ChildDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-child-detail',
  templateUrl: 'child-detail.html',
})
export class ChildDetailPage extends AbstractPage{

  @ViewChild(Content) content: Content;
  onChangeChildDetail:Subscription;
	child = {};
	family = {};
  reserveHistory = null;
  reservePhotos = null;
  _utils = Utils;

  constructor(public navCtrl: NavController, public navParams: NavParams, private pl:PhotoLibrary, private pv:PhotoViewer, private plt:Platform, private httpChildProvider:HttpChildProvider, private reserveAction:ReserveAction, private httpChatProvider:HttpChatProvider, private basicState:BasicState) {

    super();

  	this.child = this.navParams.data.child.Child;
  	this.family = this.navParams.data.family;

    this.pv; //for TSLint
    this.pl; //for TSLint
    this.plt; //for TSLint

    this.getData();

    /**
     * 子供詳細情報のリフレッシュイベント
     */
    this.onChangeChildDetail = this.basicState.onChangeChildDetail.subscribe((data)=>{
      this.child = data;
    });
  }

  /**
   * データ取得
   */
  getData(){

    //予約履歴データ取得
    this.httpChildProvider.getReserveHistory({id:this.child["id"]}).subscribe((data)=>{

      this.reserveHistory = data.data;
      var reserveIds = this.reserveAction.getReserveIds(this.reserveHistory);

      this.httpChatProvider.getListHasPhotos(reserveIds).subscribe((data2)=>{
        this.reservePhotos = data2.data;
      })
    });
  }

  /**
   * 予約画面へ遷移
   */
  goReserve(reserve){
    this.navCtrl.push(ReserveDetailPage, reserve);
  }

  convertTime(data) {
    if (!data) return "-";
    return this._Utils.date.format(new Date(data), "HH:mm");
  }

  /**
   * 子供情報編集
   */
  edit(){
    var p = {
      family:this.family,
      child:this.child,
    };
    this.navCtrl.push(ChildEditPage, p);
  }

  /**
   * 誕生日取得
   */
  getBirthday(d){
    return Utils.date.format(new Date(d), "yyyy年M月d日");
  }

  /**
   * subscription破棄
   */
  ngOnDestroy(){
    this.onChangeChildDetail.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/pages/child/detail/child-detail.ts